module.exports = __webpack_public_path__ + "static/img/cha-page-03.9d477df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/cha/cha-page-03.png
// module id = 53zK
// module chunks = 1